module.exports = __webpack_public_path__ + "img/TailWing_Overview-TW_3.a1335406.jpg";